"use client"

import { createContext, useContext, useState } from "react"

export type PaginationData = {
    page: number
    limit: number
    total: number
}

type PaginationDataContextType = {
    paginationData: PaginationData
    setPaginationData: (paginationData: PaginationData) => void
}

const PaginationDataContext = createContext<PaginationDataContextType>({
    paginationData: {
        page: 0,
        limit: 0,
        total: 0,
    },
    setPaginationData: () => {},
})

const PaginationDataContextProvider = ({
    children,
}: {
    children: React.ReactNode
}) => {
    const [paginationData, setPaginationData] = useState<PaginationData>({
        page: 0,
        limit: 0,
        total: 0,
    })

    return (
        <PaginationDataContext.Provider
            value={{
                paginationData,
                setPaginationData,
            }}
        >
            {children}
        </PaginationDataContext.Provider>
    )
}

export default PaginationDataContextProvider

export const usePaginationData = () => {
    const context = useContext(PaginationDataContext)
    if (!context) {
        throw new Error(
            "usePaginationData must be used within a PaginationDataContextProvider"
        )
    }
    return context
}
